<template>
  <div class="invoice-page">
    <div class="title">发票信息</div>
    <div class="invoice-content">
      <div class="tips">温馨提示：如需修改开票信息，请联系平台客服</div>
      <div class="type-title">发票类型</div>
      <div class="types">
        <span @click="changeType(1)" :class="['pointer type-item', type === 1 ? 'type-item-active' : '']">
          专用发票
        </span>
        <span @click="changeType(2)" :class="['pointer type-item', type === 2 ? 'type-item-active' : '']">
          普通发票
        </span>
      </div>
      <div class="form-content">
        <el-form v-show="type === 2" ref="form" :rules="rules" :model="form" label-width="150px">
          <el-form-item prop="name" label="公司名称">
            <el-input v-if="mode === 'edit'" :disabled="formData.name !== ''" v-model="form.name"></el-input>
            <span v-else>{{ form.name }}</span>
          </el-form-item>
          <el-form-item prop="taxNo" label="纳税人识别号">
            <el-input v-if="mode === 'edit'" :disabled="formData.taxNo !== ''" v-model="form.taxNo"></el-input>
            <span v-else>{{ form.taxNo }}</span>
          </el-form-item>
          <el-form-item prop="mailbox" label="收票人邮箱(电子邮箱)">
            <el-input maxlength="50" v-if="mode === 'edit'" v-model="form.mailbox"></el-input>
            <span v-else>{{ form.mailbox }}</span>
          </el-form-item>
          <el-form-item v-if="mode === 'view'">
            <el-button style="border-radius:0" type="primary" @click="mode = 'edit'">编辑</el-button>
          </el-form-item>
          <el-form-item v-else>
            <el-button style="border-radius:0" type="primary" @click="submitForm('form')">提交</el-button>
            <el-button style="border-radius:0" @click="mode = 'view'">取消</el-button>
          </el-form-item>
        </el-form>
        <el-form v-show="type === 1" ref="formSpecial" :rules="rulesSpecial" :model="formSpecial" label-width="150px">
          <el-form-item prop="name" label="公司名称">
            <el-input
              v-if="mode === 'edit'"
              :disabled="formSpecialData.name !== ''"
              v-model="formSpecial.name"
            ></el-input>
            <span v-else>{{ formSpecial.name }}</span>
          </el-form-item>
          <el-form-item prop="taxNo" label="纳税人识别号">
            <el-input
              v-if="mode === 'edit'"
              :disabled="formSpecialData.taxNo !== ''"
              v-model="formSpecial.taxNo"
            ></el-input>
            <span v-else>{{ formSpecial.taxNo }}</span>
          </el-form-item>
          <el-form-item prop="address" label="公司地址">
            <el-input
              v-if="mode === 'edit'"
              :disabled="formSpecialData.address !== ''"
              v-model="formSpecial.address"
            ></el-input>
            <span v-else>{{ formSpecial.address }}</span>
          </el-form-item>
          <el-form-item prop="openBank" label="开户银行">
            <el-input
              v-if="mode === 'edit'"
              :disabled="formSpecialData.openBank !== ''"
              v-model="formSpecial.openBank"
            ></el-input>
            <span v-else>{{ formSpecial.openBank }}</span>
          </el-form-item>
          <el-form-item prop="bankAccount" label="银行账号">
            <el-input
              v-if="mode === 'edit'"
              :disabled="formSpecialData.bankAccount !== ''"
              v-model="formSpecial.bankAccount"
            ></el-input>
            <span v-else>{{ formSpecial.bankAccount }}</span>
          </el-form-item>
          <el-form-item prop="phone" label="公司电话">
            <el-input v-if="mode === 'edit'" v-model="formSpecial.phone"></el-input>
            <span v-else>{{ formSpecial.phone }}</span>
          </el-form-item>
          <el-form-item v-if="mode === 'view'">
            <el-button style="border-radius:0" type="primary" @click="mode = 'edit'">编辑</el-button>
          </el-form-item>
          <el-form-item v-else>
            <el-button style="border-radius:0" type="primary" @click="submitForm2('formSpecial')">提交</el-button>
            <el-button style="border-radius:0" @click="mode = 'view'">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from '@/services';
import { cloneDeep } from 'lodash';
export default {
  data() {
    var validatorPhone = (rule, val, callback) => {
      var isPhone = /^([0-9]{3,4}-)?[0-9]{7,8}$/;
      var isMob = /^1\d{10}$/;
      if (isMob.test(val) || isPhone.test(val)) {
        callback();
      } else {
        callback(new Error('请输入正确的电话'));
      }
    };
    return {
      mode: 'view',
      type: 1,
      imageUrl: '',
      formData: {},
      formSpecialData: {},
      form: {
        name: '',
        taxNo: '',
        mailbox: ''
      },
      formSpecial: {
        name: '',
        taxNo: '',
        address: '',
        phone: '',
        openBank: '',
        bankAccount: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入公司名称', trigger: 'blur' },
          { min: 1, max: 50, message: '最多50个字符', trigger: 'blur' }
        ],
        taxNo: [
          { required: true, message: '请输入纳税人识别号', trigger: 'blur' },
          { min: 1, max: 50, message: '最多50个字符', trigger: 'blur' }
        ],
        mailbox: [{ required: false }]
      },
      rulesSpecial: {
        name: [
          { required: true, message: '请输入公司名称', trigger: 'blur' },
          { min: 1, max: 50, message: '最多50个字符', trigger: 'blur' }
        ],
        taxNo: [
          { required: true, message: '请输入纳税人识别号', trigger: 'blur' },
          { min: 1, max: 50, message: '最多50个字符', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入公司地址', trigger: 'blur' },
          { min: 1, max: 50, message: '最多50个字符', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入公司电话', trigger: 'blur' },
          { validator: validatorPhone, trigger: 'blur' }
        ],
        openBank: [
          { required: true, message: '请输入开户银行', trigger: 'blur' },
          { min: 1, max: 50, message: '最多50个字符', trigger: 'blur' }
        ],
        bankAccount: [
          { required: true, message: '请输入银行账号', trigger: 'blur' },
          { min: 1, max: 50, message: '最多50个字符', trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    this.getInvoice({ invoiceType: this.type });
  },
  methods: {
    getInvoice(params) {
      api.personal.getInvoiceDetail(params).then((res = {}) => {
        if (this.type === 2) {
          this.form = res;
          this.formData = cloneDeep(this.form);
        }
        if (this.type === 1) {
          this.formSpecial = res;
          this.formSpecialData = cloneDeep(this.formSpecial);
        }
      });
    },
    async saveInvoice(invoiceInfo) {
      await api.personal.modifyInvoice({ ...invoiceInfo, invoiceType: this.type });
      this.$message.success('修改成功');
      this.mode = 'view';
    },
    changeType(val) {
      this.type = val;
      this.mode = 'view';
      if (val === 1) {
        this.$refs.formSpecial.resetFields();
      } else {
        this.$refs.form.resetFields();
      }
      this.getInvoice({ invoiceType: this.type });
    },
    submitForm(formName) {
      if (this.form.mailbox && !this.form.mailbox.includes('@')) {
        this.$message('请输入正确的邮箱地址');
        return;
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.saveInvoice(this.form);
        } else {
          return false;
        }
      });
    },
    submitForm2(formName) {
      this.$refs.formSpecial.validate(valid => {
        if (valid) {
          this.saveInvoice(this.formSpecial);
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.invoice-page {
  min-height: 539px;
  background-color: #ffffff;
  .title {
    padding-left: 24px;
    height: 42px;
    border-bottom: 1px solid #eeeeee;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    line-height: 42px;
  }
  .invoice-content {
    padding: 16px;
    .tips {
      height: 46px;
      background: #f6f9ea;
      font-size: 14px;
      font-weight: 400;
      color: #d8690b;
      line-height: 46px;
      padding-left: 16px;
    }
    .type-title {
      width: 676px;
      margin: 16px auto;
      padding-left: 150px;
      font-size: 18px;
      font-weight: 400;
      color: #333333;
      line-height: 18px;
      margin-top: 16px;
    }
    .types {
      width: 676px;
      margin: 16px auto;
      padding-left: 150px;
      .type-item {
        display: inline-block;
        width: 184px;
        height: 32px;
        border: 1px dashed #dedede;
        font-size: 12px;
        font-weight: 400;
        color: #333333;
        line-height: 32px;
        margin-right: 8px;
        text-align: center;
        background-color: #fafafa;
      }
      .type-item-active {
        border: 1px solid #1e8dff;
        background-color: #ffffff;
        color: #1e8dff;
        background: #fff url('../../assets/img/trian-right-icon.png') right bottom no-repeat;
        background-size: 17px 17px;
      }
    }
    .form-content {
      width: 676px;
      margin: 16px auto;
    }
  }
}
::v-deep .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
::v-deep .el-upload:hover {
  border-color: #1bbf75;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
